import { Modal, Button } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";

function OnlinePaymentComplete({ show, onHide, donation, onConfirm }) {

  const handleConfirm = () => {
    onConfirm({
      appointment_id: donation.appointment_id,
      payment_type: "online"
    });
    onHide();
  };

  return (
    <Modal show={show} centered onHide={onHide} dialogClassName="el-deactivate-modal">
      {/* <Modal.Header closeButton>
        <Modal.Title>Mark Payment Completed</Modal.Title>
      </Modal.Header> */}

      <Modal.Body> 
        <h5 className="mb-3">
          Mark Payment Completed
        </h5>

        <p>
          Are you sure you want to mark this <b>online payment</b> as completed?
        </p>

       <div className="d-flex justify-content-start mt-4">
                {/* <Modal.Footer> */}
        <button
            type="submit"
            className="el-main-button"  onClick={handleConfirm}>
          <span>Payment Completed</span>
        </button>
        <button
          type="button"
          className="back-link close-btn ms-3" onClick={onHide}>
          Close
        </button>
        </div>
      </Modal.Body>


      {/* </Modal.Footer> */}
    </Modal>
  );
}

export default OnlinePaymentComplete;
